import React from 'react';
import { graphql } from 'gatsby';
import Container from '../components/container';
import GraphQLErrorList from '../components/graphql-error-list';
import SEO from '../components/seo';
import Layout from '../containers/layout';
import ProjectsContent from '../components/project-single';

export const query = graphql`
  query projecTemplateQuery($id: String!) {
    project: sanityProject(id: { eq: $id }) {
      ...SanityProjectFragment
      seoTitle
      seoDescription
      seoKeywords
      socialImage {
        asset {
          url
        }
      }
    }
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      ...SanitySiteSettingsFragment
    }
  }
`;

const projectTemplateQuery = props => {
  const { data, errors } = props;
  const { seoTitle, seoDescription, seoKeywords, socialImage } = data.project || {};
  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const projectNode = data.project;
  const projectGridNodes = data.site.projectsGrid;

  return (
    <Layout>
      <SEO
        title={seoTitle ? seoTitle : projectNode.title}
        description={seoDescription ? seoDescription : projectNode.tagline}
        keywords={seoKeywords}
        ogImage={socialImage?.asset?.url}
      />
      <Container>
        {projectNode && <ProjectsContent node={projectNode} nodes={projectGridNodes} />}
      </Container>
    </Layout>
  );
};

export default projectTemplateQuery;
